import React from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";

import DeliveryFeeCalculator from "./pages/DeliveryFeeCalculator";
import { MunchiURLs } from "./constants/cons";

const Header: React.FC = () => (
  <header className="container relative mx-auto flex justify-between items-center px-8 py-6">
    <div>
      <a href={MunchiURLs.mainpage} className="text-black font-bold text-xl">
        munchi
      </a>
    </div>

    <div>
      <a href={MunchiURLs.login} className="text-black font-bold text-xl">
        Login
      </a>
      <Link
        to="/"
        className="ml-6 font-roboto font-bold bg-black text-white py-4 px-6 rounded-full hover:opacity-80"
      >
        Calculator
      </Link>
    </div>
  </header>
);

const MainContent: React.FC = () => (
  <main className="container relative max-w-4xl mx-auto lg:my-16 my-10">
    <Routes>
      <Route path="/" element={<DeliveryFeeCalculator />} />
    </Routes>
  </main>
);

const App: React.FC = () => {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Header />
      <MainContent />
    </BrowserRouter>
  );
};

export default App;
